export class CreateFindingExclusionRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "scope",
            "baseName": "scope",
            "type": "FindingExclusionScope",
            "format": ""
        },
        {
            "name": "providerResourceId",
            "baseName": "providerResourceId",
            "type": "string",
            "format": ""
        },
        {
            "name": "value",
            "baseName": "value",
            "type": "string",
            "format": ""
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "FindingObjectType",
            "format": ""
        },
        {
            "name": "detector",
            "baseName": "detector",
            "type": "FindingExclusionDetectorType",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CreateFindingExclusionRequest.attributeTypeMap;
    }
    constructor() {
    }
}
